import { GET } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 特卖入场列表
 */
export const fetchDigtailQList = async (shopping_village) => {
    const res = await GET(APIs.API_DIGTAILQ_LIST, { params: { shopping_village } });

    return res.data.data ?? {};
};